(ns practitest.frontend.landing.account-info
  (:require [practitest.frontend.components2.container-card :refer [container-card]]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.components.markdown3 :refer [markdown-preview]]
            [practitest.frontend.components.icons :as icons]
            [re-frame.core :as re-frame]))

(defn account-info []
  (let [account-message @(re-frame/subscribe [:landing/account-message])
        display-message? @(re-frame/subscribe [:landing/display-account-message])
        account @(re-frame/subscribe [:landing/account])
        dashboard-settings-path (:dashboard_settings_path account)]

    (when display-message?
      [:div.pt-section
       [:div.pt-container-card-header
        [:h3.pt-container-card-title [icons/mux-message] (get-translation "landing.message-board" "Message Board")]
        [:a {:href dashboard-settings-path :target "_blank"}
         (get-translation "landing.customize" "Customize")]]
       [container-card
        {:class "pt-account-info-card"}
        [:div.pt-container-card-message
         [markdown-preview account-message]]]])))
